var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretRightThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.12499C15.0742 4.12499 15.1467 4.14698 15.2084 4.18818C15.27 4.22937 15.3181 4.28794 15.3465 4.35645C15.3749 4.42497 15.3823 4.50036 15.3679 4.5731C15.3534 4.64584 15.3177 4.71267 15.2653 4.76512L8.03039 12L15.2653 19.2349C15.3356 19.3052 15.3751 19.4006 15.3751 19.5001C15.375 19.5995 15.3355 19.6949 15.2652 19.7652C15.1948 19.8355 15.0994 19.875 15 19.875C14.9005 19.875 14.8051 19.8355 14.7348 19.7651L7.23483 12.2651C7.16453 12.1948 7.12503 12.0994 7.12503 12C7.12503 11.9006 7.16453 11.8052 7.23483 11.7349L14.7348 4.23487C14.7696 4.19998 14.811 4.17231 14.8565 4.15346C14.902 4.1346 14.9508 4.12493 15 4.12499Z",
    fill: "var(--color, #BDBFBF)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightThin);
export default __webpack_public_path__ + "static/media/caret-right-thin.520a2389fba62783bab7fdaf3f0584fc.svg";
export { ForwardRef as ReactComponent };